import type { AdminClientContext, AdminHttpClient } from './client.js';

type MethodKeys = 'downloadLatestForUser';

export function buildDownloadsMethods(ctx: AdminClientContext) {
  const { transport, token } = ctx;

  return {
    downloadLatestForUser: ({ userId, channel, platform }) =>
      transport.downloadLatestForUser(token(), { userId, channel, platform }),
  } satisfies Pick<AdminHttpClient, MethodKeys>;
}
